const excelCheatSheet = {
  id: "excel",
  title: "Excel Cheatsheet",
  description: "Complete guide to Microsoft Excel formulas and features",
  language: "excel",
  category: "Data Analysis",
  level: "All Levels",
  sections: [
    {
      title: "Essential Functions",
      items: [
        {
          title: "Basic Functions",
          content: "Commonly used Excel functions",
          code: `# Math Functions
=SUM(range)              # Add numbers in a range
=AVERAGE(range)          # Calculate average
=COUNT(range)            # Count numbers
=COUNTA(range)           # Count non-empty cells

# Text Functions
=CONCATENATE(text1,text2)  # Join text
=LEFT(text,num_chars)      # Left characters
=RIGHT(text,num_chars)     # Right characters
=LEN(text)                 # Text length`,
          note: "Use F4 to toggle absolute/relative references",
        },
        {
          title: "Lookup Functions",
          content: "Find and reference data",
          code: `# VLOOKUP
=VLOOKUP(lookup_value, table_array, col_index, [range_lookup])
Example: =VLOOKUP(A2, B2:D10, 2, FALSE)

# INDEX MATCH
=INDEX(return_range, MATCH(lookup_value, lookup_range, 0))
Example: =INDEX(C2:C10, MATCH(A2, B2:B10, 0))

# XLOOKUP (Excel 365)
=XLOOKUP(lookup_value, lookup_array, return_array)
Example: =XLOOKUP(A2, B2:B10, C2:C10)`,
          note: "XLOOKUP is more versatile than VLOOKUP",
        },
      ],
    },
    {
      title: "Data Analysis",
      items: [
        {
          title: "Conditional Functions",
          content: "Logic and conditional operations",
          code: `# IF Statement
=IF(logical_test, value_if_true, value_if_false)
Example: =IF(A1>10, "High", "Low")

# Nested IF
=IF(A1>10, "High", IF(A1>5, "Medium", "Low"))

# IFS (Excel 365)
=IFS(A1>10, "High", A1>5, "Medium", TRUE, "Low")

# SUMIF/COUNTIF
=SUMIF(range, criteria, [sum_range])
=COUNTIF(range, criteria)`,
          note: "Use IFS instead of nested IF when possible",
        },
        {
          title: "Array Formulas",
          content: "Advanced array operations",
          code: `# Array Formula (CSE)
{=SUM(IF(range>0,range))}    # Sum positive numbers

# SUMPRODUCT
=SUMPRODUCT(range1,range2)    # Multiply and sum arrays

# Dynamic Arrays (Excel 365)
=FILTER(range, criteria)       # Filter data
=SORT(range, [sort_index])    # Sort data
=UNIQUE(range)                # Get unique values`,
          note: "Press Ctrl+Shift+Enter for legacy array formulas",
        },
      ],
    },
    {
      title: "Data Formatting",
      items: [
        {
          title: "Number Formatting",
          content: "Format numbers and dates",
          code: `# Custom Number Formats
General:    0.00
Percentage: 0.00%
Currency:   $#,##0.00
Date:       dd/mm/yyyy
Time:       hh:mm:ss

# Conditional Formatting
Rules → New Rule
Color Scales
Data Bars
Icon Sets`,
          note: "Use Format Painter to copy formatting quickly",
        },
        {
          title: "Cell Styles",
          content: "Apply and manage styles",
          code: `# Built-in Styles
Normal
Currency
Percent
Title
Heading 1-4

# Custom Styles
New Cell Style
Modify Style
Merge Styles`,
          note: "Create style templates for consistency",
        },
      ],
    },
    {
      title: "Keyboard Shortcuts",
      items: [
        {
          title: "Navigation Shortcuts",
          content: "Move around efficiently",
          code: `# Basic Navigation
Ctrl + ↑/↓/←/→     # Move to edge of data
Ctrl + Home        # Go to start of sheet
Ctrl + End         # Go to end of data
Ctrl + G          # Go to specific cell

# Selection
Shift + ↑/↓/←/→   # Extend selection
Ctrl + Space      # Select column
Shift + Space     # Select row
Ctrl + A          # Select all`,
          note: "Master these for faster navigation",
        },
        {
          title: "Editing Shortcuts",
          content: "Quick editing commands",
          code: `# Common Actions
Ctrl + C          # Copy
Ctrl + X          # Cut
Ctrl + V          # Paste
Ctrl + Z          # Undo
Ctrl + Y          # Redo

# Formatting
Ctrl + 1          # Format cells
Ctrl + B          # Bold
Ctrl + I          # Italic
Ctrl + U          # Underline`,
          note: "Learn these to work faster",
        },
      ],
    },
    {
      title: "Advanced Features",
      items: [
        {
          title: "PivotTables",
          content: "Create and modify PivotTables",
          code: `# Create PivotTable
Insert → PivotTable
Select data range
Choose destination

# PivotTable Elements
Filters:    Top of report
Columns:    Column headers
Rows:       Row headers
Values:     Calculated fields`,
          note: "Use PivotTables for data summarization",
        },
        {
          title: "Data Validation",
          content: "Control data entry",
          code: `# Set Validation
Data → Data Validation
List:     Create dropdown
Custom:   Formula-based
Date:     Date range
Time:     Time range

# Error Alerts
Input Message
Error Alert
Custom Error`,
          note: "Prevent invalid data entry",
        },
      ],
    },
  ],
};

export default excelCheatSheet;
